/* ============
 * Create Page
 * ============
 *
 * This page creates client.
 */

import { mapGetters } from 'vuex';
import unitOfMeasureService from './../../../../services/unitOfMeasure';
import unitOfMeasureTransformer from './../../../../transformers/unitOfMeasure';
import Forms from './../../../../utils/forms/forms';

export default {
  data() {
    return {
      formBasicInformation: new Forms({
        name: {
          value: '',
          type: 'text',
        },
        code: {
          value: '',
          type: 'text',
        },
      }),
      loading: true,
      tabIndex: 'first',
    };
  },

  computed: {
    ...mapGetters({
      unitOfMeasure:'currentUnitOfMeasure'
    }),
  },

  watch: {
  },

  created() {
    this.show();
  },

  methods: {
    /**
     * Method to store the client
     */
    update() {
      this.loading = false;
      this.formBasicInformation.loading = true;
      const supp = unitOfMeasureTransformer.send(
        Object.assign({}, this.formBasicInformation.data())
      );
      console.log(supp);
      unitOfMeasureService.update(this.$route.params.id, supp)
      .then(() => {
        this.$message({
          message: this.$t('static.unitOfMeasure.update.success'),
          type: 'success',
        });
        this.$router.push({
          name: 'unitOfMeasure.index',
        });
      }).catch((errors) => {
        this.formBasicInformation.loading = false;
        this.formBasicInformation.recordErrors(errors);

      });
    },

    /**
     * Fetches the unitOfMeasure object for editing.
     */
    show() {
      this.loading = true;
      Promise.all([
        unitOfMeasureService.show(this.$route.params.id),
      ]).then((data) => {
        this.loading = false;
        const ware = data[0]
        this.formBasicInformation.assignData(ware);
      });
    },
  },

  components: {
    VForm: require('./../../../../components/form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/unitOfMeasure/edit/edit.js